import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => err);
      }

      // 403 PROFILE_INCOMPLETE — redirect without clearing the session
      if (err.status === 403) {
        const authErr = authService.getAuthError(err);
        if (authErr?.code === 'PROFILE_INCOMPLETE') {
          void router.navigate(['/auth/complete-profile']);
        }
        return throwError(() => err);
      }

      if (err.status !== 401) {
        return throwError(() => err);
      }

      // Auth endpoints returning 401 are self-contained failures (wrong credentials,
      // expired token, etc.) — never trigger a refresh for them.
      if (req.url.includes('/api/auth/')) {
        authService.clearUser();
        void router.navigate(['/auth/login']);
        return throwError(() => err);
      }

      // Attempt a single token refresh, then retry the original request.
      return authService.refreshToken().pipe(
        switchMap(() => next(req)),
        catchError((refreshErr: unknown) => {
          authService.clearUser();
          void router.navigate(['/auth/login']);
          return throwError(() => refreshErr);
        }),
      );
    }),
  );
};